export default __webpack_public_path__ + "static/media/HONEY.49a2bd5d.png";